import React, {useEffect, useState} from 'react';
import {Button, Text, TextField} from '@cloudaper/react';

const Step2 = props => {
  const {
    validateToken,
    handleRoomCreate,
    handleRoomNameChange,
    roomDisplayName,
    roomSystemName,
    validatingRoomSystemName,
    validRoomSystemName,
  } = props;

  useEffect(() => {
    document.title = 'Nastavení firemního účtu - Začněte s Document Managerem';

    window.Intercom('trackEvent', 'completed-1st-step-on-onboarding');
    if (window.dataLayer) {
      window.dataLayer.push({event: 'completed-1st-step-on-onboarding'});
    }

    validateToken();
  }, [validateToken]);

  const [creatingRoom, setCreatingRoom] = useState(false);

  const createRoom = () => {
    setCreatingRoom(true);
    handleRoomCreate();
  };

  return (
    <div className="appWrapper">
      <div className="appConnectorString" />

      <Text className="appConnectorCounter">2</Text>

      <div className="appContent">
        <Text className="appHeading centeredText">Nastavte si</Text>
        <Text className="appHeading centeredText">Document Manager</Text>
        <Text className="appHeading centeredText">pro vaši firmu</Text>
        <br />
        <Text className="centeredText cardBodyText">
          Pojmenujte si firemní účet, ve kterém budete pracovat se svými
          dokumenty.
        </Text>

        <br />
        <TextField
          error={
            !roomDisplayName && roomSystemName
              ? 'Zadejte prosím jméno'
              : undefined
          }
          success={roomDisplayName && roomSystemName ? 'V pořádku' : undefined}
          handleEnter={!creatingRoom ? createRoom : undefined}
          label="Název účtu"
          placeholder="Moje firma s.r.o."
          focusedHelper="Např. oficiální název vaší firmy"
          onChange={e => {
            e.stopPropagation();
            handleRoomNameChange(e);
          }}
          value={roomDisplayName}
          id="dm-onboarding-step2-1"
        />
        <TextField
          error={
            !validatingRoomSystemName && roomSystemName && !validRoomSystemName
              ? 'Název není k dispozici'
              : undefined
          }
          success={
            !validatingRoomSystemName && roomSystemName && validRoomSystemName
              ? 'OK'
              : undefined
          }
          helper="Použije se třeba v e-mailové adrese"
          focusedHelper="Malá písmena bez diakritiky, číslice a pomlčky"
          handleEnter={!creatingRoom ? createRoom : undefined}
          label="Systémový název účtu"
          placeholder="moje-firma-sro"
          onChange={e => {
            e.stopPropagation();
            handleRoomNameChange(e, 'system');
          }}
          value={roomSystemName}
          id="dm-onboarding-step2-2"
        />
        <br />
        <Text className="cardBodyText">
          <em>
            Document Manager si můžete vyzkoušet zcela nezávazně a zdarma na 14 dní.
            Během zkušební doby se vám ozveme a doladíme společně nastavení, smlouvu a platbu.
          </em>
        </Text>
      </div>

      <div className="appConnectorButtonWrapper">
        <Button
          className="appConnectorButton"
          disabled={!roomDisplayName || !validRoomSystemName}
          kind="primary"
          onClick={!creatingRoom ? createRoom : undefined}
          raised
        >
          {validatingRoomSystemName ? 'Ověřuji dostupnost' : 'Pojmenovat'}
        </Button>
      </div>
    </div>
  );
};

export default Step2;
